import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const createpoitemSlice = createApi({
    reducerPath: "createpoitem",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        createpoitem: builder.mutation({
            query: (data) => ({ url: "/inventory/api/v1/poitem/create", method: "POST", body: data }),
        }),
    }),
});

export const { useCreatepoitemMutation } = createpoitemSlice;
